export default __webpack_public_path__ + "static/media/Contact.48afebc6.svg";